const GetFormatDate = (dataAtual, withUtc = true, comBarra = true) => {
  if (withUtc === true) {
    const data = new Date(dataAtual);

    const dataUTC3 = new Date(data.getTime() - 3 * 60 * 60 * 1000);

    const dia = String(dataUTC3.getDate()).padStart(2, "0");
    const mes = String(dataUTC3.getMonth() + 1).padStart(2, "0");
    const ano = dataUTC3.getFullYear();

    return comBarra ? `${dia}/${mes}/${ano}` : `${ano}-${mes}-${dia}`;
  }
  const data = new Date(dataAtual);

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();

  return comBarra ? `${dia}/${mes}/${ano}` : `${ano}-${mes}-${dia}`;
};

export default GetFormatDate;
